var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FBC02D",
  d: "M22.472 10.008h-.819v-.042H12.5v4.068h5.748A6.1 6.1 0 0 1 6.398 12 6.1 6.1 0 0 1 12.5 5.898a6.07 6.07 0 0 1 4.048 1.545l2.877-2.876A10.12 10.12 0 0 0 12.5 1.83C6.884 1.83 2.33 6.384 2.33 12S6.884 22.17 12.5 22.17 22.67 17.616 22.67 12c0-.682-.07-1.348-.198-1.992"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E53935",
  d: "m3.503 7.266 3.341 2.45A6.1 6.1 0 0 1 12.5 5.899a6.07 6.07 0 0 1 4.048 1.545l2.877-2.876A10.12 10.12 0 0 0 12.5 1.83a10.16 10.16 0 0 0-8.997 5.436"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#4CAF50",
  d: "M12.5 22.17c2.627 0 5.014-1.005 6.818-2.64l-3.147-2.664a6.06 6.06 0 0 1-3.671 1.236 6.1 6.1 0 0 1-5.738-4.04l-3.316 2.555C5.129 19.91 8.547 22.17 12.5 22.17"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#1565C0",
  d: "m22.472 10.008-.008-.042H12.5v4.068h5.748a6.1 6.1 0 0 1-2.077 2.832l3.147 2.664c-.223.202 3.352-2.445 3.352-7.53 0-.682-.07-1.348-.198-1.992"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleIcon);
export default ForwardRef;